import React, { useRef, useMemo, useEffect } from "react";
import { Card, Image } from "react-bootstrap";
import { changeLanguage, setAppPage } from "../../../store/actions/actions";
import { connect } from "react-redux";

import LeftBar from "./LeftBar";
import NavBar from "./NavBar";
import ProjectRedux from "../ProjectRedux";
import Chat from "./Chat";
import * as ProjectStyle from "../project.module.css";
import { useHistory } from "react-router";
import { appsAvailable } from "../../data";
import firebase from "firebase";
import { useCollection } from "react-firebase-hooks/firestore";
import moment from "moment";
import { Skeleton } from "@material-ui/lab";

function Apps({ project, setAppPage }) {
  const pageRef = useRef(null);
  useEffect(() => {
    pageRef && pageRef.current.scrollIntoView();
  }, []);

  const history = useHistory();

  const [folderDataSnapshot, folderDataLoading, folderDataError] =
    useCollection(
      firebase
        .firestore()
        .collection(
          "/workspaces/LgT2sjzoZQwwKMGPnob2/rooms/I5ZwggPkyQpeCdRpcl1M/folders"
        )
        .orderBy("timestamp", "desc")
    );

  const folderData = useMemo(() => {
    return folderDataSnapshot?.docs?.map((e) => {
      return { id: e.id, ...e.data() };
    });
  }, [folderDataSnapshot]);

  const LoadingSkeleton = () => {
    return [1, 2, 3].map((item) => (
      <div className="col-2 pr-0" key={item}>
        <div className="p-2 rounded">
          <Skeleton
            animation="wave"
            variant="rect"
            className="bg-muted rounded"
            height={80}
          />
          <Skeleton
            animation="wave"
            className="bg-muted rounded mt-1"
            height={20}
          />
        </div>
      </div>
    ));
  };

  return (
    <>
      <ProjectRedux />
      <div className="h-100" ref={pageRef}>
        <LeftBar mobile />
        <div className="container-fluid h-100" style={{ overflow: "hidden" }}>
          <NavBar />
          <div className="row" style={{ height: "93vh", overflow: "hidden" }}>
            <LeftBar />
            <div
              className="col-md-7 h-100 p-md-5 p-3 bg-graphite"
              style={{ overflow: "scroll" }}
            >
              <div className=" bg-graphite ">
                <div className="">
                  <h2 className="font-weight-bold text-white">Applications</h2>

                  <div className="mt-3 mt-md-4">
                    <div className="row mb-3 mb-md-5">
                      {appsAvailable?.map((item, key) => {
                        return (
                          <div className="col-3 pr-0" key={key}>
                            <Card
                              className={`${ProjectStyle.app_icon} shadow-sm mb-3 text-white`}
                              title={item.name}
                              onClick={() => {
                                if (item.route == "folder") {
                                  history.push(`apps/folder`);
                                  setAppPage(item);
                                } else {
                                  history.push(`apps/${item.route}`);
                                  setAppPage(item);
                                }
                              }}
                            >
                              <Card.Body className="px-3 pt-3 pb-2">
                                <Image
                                  src={item.icon_image}
                                  className={ProjectStyle.app_icon_image}
                                />
                                <p className="mb-0 p-1 text-uppercase small font-weight-bold">
                                  {item.name}
                                </p>
                              </Card.Body>
                            </Card>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="">
                  <div className="d-flex align-items-center rounded border border-dark">
                    <img
                      src={
                        "data:image/png;base64,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"
                      }
                      className={`bg-dark p-1 ${ProjectStyle.folder_icon_image}`}
                      alt=""
                    />
                    <h2 className="font-weight-bold text-white mx-2 mb-0">
                      Folders
                    </h2>
                  </div>
                  {/* <h2 className="font-weight-bold text-white">Folders</h2> */}

                  <div className="mt-3 mt-md-4">
                    <div className="row">
                      {folderDataLoading && <LoadingSkeleton />}

                      {folderData?.map((item, idx) => (
                        <div
                          className="col-2 pr-0"
                          key={idx}
                          title={`Folder: ${item?.folderName}`}
                        >
                          <div
                            className={`${ProjectStyle.folder_icon} text-white text-center px-3 py-2 rounded`}
                            onClick={() =>
                              history.push(`./apps/folder/${item.id}`)
                            }
                          >
                            <Image
                              className="img-fluid"
                              src={`${process.env.PUBLIC_URL}/assets/folder-icon.png`}
                            />
                            <p className="mb-0 font-weight-bold">
                              {item?.folderName}
                            </p>
                            {/* <p className="mb-0 small text-muted">
                              {item?.folderDesignation}
                            </p> */}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Chat module */}
            <div
              className="col-md-4 h-100 px-0 d-flex flex-column justify-content-between"
              style={{ overflow: "scroll" }}
            >
              <Chat />
            </div>
            {/* Chat module ends */}
          </div>
        </div>
      </div>
    </>
  );
}

export default connect(
  (state) => ({
    currentLanguage: state.currentLanguage,
    project: state.project,
  }),
  { changeLanguage, setAppPage }
)(Apps);
